export const upcomingPayments = [
  {
    id: "1",
    title: "HDFC Credit Card Bill",
    amount: 450.0,
    dueDate: "2026-05-29",
    category: "Credit Card",
    frequency: "Monthly",
    status: "pending",
    icon: "ri-bank-card-line",
    color: "#6366f1",
  },
  {
    id: "2",
    title: "Netflix Premium",
    amount: 15.99,
    dueDate: "2026-05-31",
    category: "OTT Subscription",
    frequency: "Monthly",
    status: "pending",
    icon: "ri-tv-line",
    color: "#ec4899",
  },
  {
    id: "3",
    title: "Electricity Bill - May",
    amount: 87.5,
    dueDate: "2026-05-28",
    category: "Utility",
    frequency: "Monthly",
    status: "pending",
    icon: "ri-flashlight-line",
    color: "#f59e0b",
  },
  {
    id: "4",
    title: "Car Loan EMI",
    amount: 320.0,
    dueDate: "2026-06-02",
    category: "EMI",
    frequency: "Monthly",
    status: "pending",
    icon: "ri-car-line",
    color: "#10b981",
  },
  {
    id: "5",
    title: "Jio Fiber Internet",
    amount: 49.99,
    dueDate: "2026-06-05",
    category: "Internet",
    frequency: "Monthly",
    status: "pending",
    icon: "ri-wifi-line",
    color: "#3b82f6",
  },
  {
    id: "6",
    title: "LIC Insurance Premium",
    amount: 200.0,
    dueDate: "2026-06-10",
    category: "Insurance",
    frequency: "Quarterly",
    status: "pending",
    icon: "ri-shield-check-line",
    color: "#8b5cf6",
  },
  {
    id: "7",
    title: "Apartment Rent",
    amount: 1200.0,
    dueDate: "2026-06-01",
    category: "Rent",
    frequency: "Monthly",
    status: "pending",
    icon: "ri-home-4-line",
    color: "#ef4444",
  },
];

export const recentPayments = [
  {
    id: "8",
    title: "Spotify Premium",
    amount: 9.99,
    dueDate: "2026-05-18",
    category: "OTT Subscription",
    frequency: "Monthly",
    status: "paid",
    icon: "ri-music-line",
    color: "#22c55e",
  },
  {
    id: "9",
    title: "PhonePe Mobile Recharge",
    amount: 29.99,
    dueDate: "2026-05-20",
    category: "Mobile",
    frequency: "Monthly",
    status: "paid",
    icon: "ri-smartphone-line",
    color: "#06b6d4",
  },
  {
    id: "10",
    title: "Amazon Prime",
    amount: 14.99,
    dueDate: "2026-05-10",
    category: "OTT Subscription",
    frequency: "Yearly",
    status: "overdue",
    icon: "ri-shopping-bag-line",
    color: "#f97316",
  },
];

export const quickStats = {
  totalDueThisMonth: 2323.48,
  upcomingCount: 7,
  paidThisMonth: 12,
  overdueCount: 1,
  monthlyBudget: 3500.0,
};

export const categories = [
  { name: "Credit Card", icon: "ri-bank-card-line", color: "#6366f1" },
  { name: "EMI", icon: "ri-car-line", color: "#10b981" },
  { name: "Utility", icon: "ri-flashlight-line", color: "#f59e0b" },
  { name: "OTT Subscription", icon: "ri-tv-line", color: "#ec4899" },
  { name: "Insurance", icon: "ri-shield-check-line", color: "#8b5cf6" },
  { name: "Rent", icon: "ri-home-4-line", color: "#ef4444" },
  { name: "Internet", icon: "ri-wifi-line", color: "#3b82f6" },
  { name: "Mobile", icon: "ri-smartphone-line", color: "#06b6d4" },
  { name: "Tax", icon: "ri-file-text-line", color: "#64748b" },
  { name: "Education", icon: "ri-book-open-line", color: "#14b8a6" },
  { name: "Business", icon: "ri-briefcase-line", color: "#78716c" },
  { name: "Other", icon: "ri-more-line", color: "#94a3b8" },
];